<div class="single-match-field"
	 (click)="copyToClipboard()">
	<div class="value-content">
		<span class="name">
			{{labelPublicRecord}}:
		</span>
		<span class="value">
			{{dataPublicRecord || '--'}}
		</span>

	</div>
	<i *ngIf="dataPublicRecord"
	   class="fa fa-window-restore"
	   aria-hidden="true"></i>
</div>